import axios from 'axios';

export const fetchAllPages = async (baseUrl, dataKey, params = {}, axiosConfig = {}, perPage = 50) => {
  const makeUrl = (page) => {
    const qs = new URLSearchParams({ ...params, page, per_page: perPage });
    return `${baseUrl}?${qs}`;
  };
  const firstRes = await axios.get(makeUrl(1), axiosConfig);
  const { [dataKey]: firstItems, pages } = firstRes.data;
  if (pages <= 1) return firstItems;
  const remaining = await Promise.all(
    Array.from({ length: pages - 1 }, (_, i) => axios.get(makeUrl(i + 2), axiosConfig))
  );
  return [...firstItems, ...remaining.flatMap(r => r.data[dataKey])];
};
